import { render, staticRenderFns } from "./Nonus.vue?vue&type=template&id=5b6d7bd4&scoped=true"
import script from "./Nonus.vue?vue&type=script&lang=js"
export * from "./Nonus.vue?vue&type=script&lang=js"
import style0 from "./Nonus.vue?vue&type=style&index=0&id=5b6d7bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d7bd4",
  null
  
)

export default component.exports